import React from "react";
import { Link, useLocation } from "react-router-dom";

const NavbarMobile = () => {
  const { pathname } = useLocation();
  const MENU_ITEMS = [
    {
      svg: (
        <svg
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.2838 3.22174C12.1877 2.26393 10.4571 2.26393 9.36103 3.22174L3.53604 8.3118C3.39332 8.43651 3.29732 8.59897 3.26164 8.77614C2.56395 12.2409 2.51245 15.788 3.1093 19.2684L3.25097 20.0946H6.99853V12.9728C6.99853 12.4978 7.42131 12.1128 7.94283 12.1128H14.702C15.2236 12.1128 15.6463 12.4978 15.6463 12.9728V20.0946H19.3939L19.5356 19.2684C20.1324 15.7881 20.0809 12.2409 19.3832 8.77614C19.3475 8.59897 19.2515 8.43651 19.1088 8.3118L13.2838 3.22174ZM8.05343 1.98077C9.88026 0.384421 12.7646 0.384421 14.5914 1.98077L20.4164 7.07083C20.8452 7.44553 21.1337 7.93362 21.2408 8.46593C21.9768 12.1208 22.0311 15.8625 21.4015 19.5338L21.1739 20.861C21.0798 21.4098 20.5607 21.8144 19.9507 21.8144H14.702C14.1805 21.8144 13.7577 21.4294 13.7577 20.9545V13.8327H8.88713V20.9545C8.88713 21.4294 8.46435 21.8144 7.94283 21.8144H2.69413C2.08413 21.8144 1.56503 21.4098 1.47091 20.861L1.24332 19.5338C0.613727 15.8625 0.668053 12.1208 1.40401 8.46593C1.5112 7.93362 1.79963 7.44553 2.22843 7.07083L8.05343 1.98077Z"
            fill="#241E40"
          />
        </svg>
      ),
      path: "/trang-chu",
    },
    {
      svg: (
        <svg
          width="23"
          height="22"
          viewBox="0 0 23 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.96377 2.63259C6.49989 2.46906 4.98455 2.46906 3.52067 2.63259C3.16497 2.67232 2.88445 2.95383 2.84444 3.29574C2.66963 4.78961 2.66963 6.29876 2.84444 7.79263C2.88445 8.13453 3.16497 8.41605 3.52067 8.45578C4.98455 8.61931 6.49989 8.61931 7.96377 8.45578C8.31948 8.41605 8.6 8.13453 8.64001 7.79263C8.81482 6.29876 8.81482 4.78961 8.64001 3.29574C8.6 2.95383 8.31948 2.67232 7.96377 2.63259ZM3.32881 0.916835C4.9202 0.739066 6.56424 0.739066 8.15564 0.916835C9.29664 1.04429 10.2207 1.94202 10.3556 3.09518C10.5461 4.7223 10.5461 6.36607 10.3556 7.99319C10.2207 9.14635 9.29664 10.0441 8.15563 10.1715C6.56424 10.3493 4.9202 10.3493 3.32881 10.1715C2.1878 10.0441 1.26374 9.14635 1.1288 7.99319C0.938391 6.36607 0.938391 4.7223 1.1288 3.09518C1.26374 1.94203 2.1878 1.04429 3.32881 0.916835Z"
            fill="#241E40"
            fillOpacity="0.85"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.96377 14.1422C6.49989 13.9786 4.98455 13.9786 3.52067 14.1422C3.16497 14.1819 2.88445 14.4634 2.84444 14.8053C2.66963 16.2992 2.66963 17.8083 2.84444 19.3022C2.88445 19.6441 3.16497 19.9256 3.52067 19.9654C4.98455 20.1289 6.49989 20.1289 7.96377 19.9654C8.31948 19.9256 8.6 19.6441 8.64001 19.3022C8.81482 17.8083 8.81482 16.2992 8.64001 14.8053C8.6 14.4634 8.31948 14.1819 7.96377 14.1422ZM3.32881 12.4264C4.9202 12.2486 6.56424 12.2486 8.15564 12.4264C9.29664 12.5539 10.2207 13.4516 10.3556 14.6048C10.5461 16.2319 10.5461 17.8756 10.3556 19.5028C10.2207 20.6559 9.29664 21.5537 8.15563 21.6811C6.56424 21.8589 4.9202 21.8589 3.32881 21.6811C2.1878 21.5537 1.26374 20.6559 1.1288 19.5028C0.938391 17.8756 0.938391 16.2319 1.1288 14.6048C1.26374 13.4516 2.1878 12.5539 3.32881 12.4264Z"
            fill="#241E40"
            fillOpacity="0.85"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.4794 2.63259C18.0155 2.46906 16.5001 2.46906 15.0362 2.63259C14.6805 2.67232 14.4 2.95383 14.36 3.29574C14.1852 4.78961 14.1852 6.29876 14.36 7.79263C14.4 8.13453 14.6805 8.41605 15.0362 8.45578C16.5001 8.61931 18.0155 8.61931 19.4794 8.45578C19.8351 8.41605 20.1156 8.13453 20.1556 7.79263C20.3304 6.29876 20.3304 4.78961 20.1556 3.29574C20.1156 2.95383 19.8351 2.67232 19.4794 2.63259ZM14.8444 0.916835C16.4358 0.739066 18.0798 0.739066 19.6712 0.916835C20.8122 1.04429 21.7363 1.94202 21.8712 3.09518C22.0616 4.7223 22.0616 6.36607 21.8712 7.99319C21.7363 9.14635 20.8122 10.0441 19.6712 10.1715C18.0798 10.3493 16.4358 10.3493 14.8444 10.1715C13.7034 10.0441 12.7793 9.14635 12.6444 7.99319C12.454 6.36607 12.454 4.7223 12.6444 3.09518C12.7793 1.94203 13.7034 1.04429 14.8444 0.916835Z"
            fill="#241E40"
            fillOpacity="0.85"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.4794 14.1422C18.0155 13.9786 16.5001 13.9786 15.0362 14.1422C14.6805 14.1819 14.4 14.4634 14.36 14.8053C14.1852 16.2992 14.1852 17.8083 14.36 19.3022C14.4 19.6441 14.6805 19.9256 15.0362 19.9654C16.5001 20.1289 18.0155 20.1289 19.4794 19.9654C19.8351 19.9256 20.1156 19.6441 20.1556 19.3022C20.3304 17.8083 20.3304 16.2992 20.1556 14.8053C20.1156 14.4634 19.8351 14.1819 19.4794 14.1422ZM14.8444 12.4264C16.4358 12.2486 18.0798 12.2486 19.6712 12.4264C20.8122 12.5539 21.7363 13.4516 21.8712 14.6048C22.0616 16.2319 22.0616 17.8756 21.8712 19.5028C21.7363 20.6559 20.8122 21.5537 19.6712 21.6811C18.0798 21.8589 16.4358 21.8589 14.8444 21.6811C13.7034 21.5537 12.7793 20.6559 12.6444 19.5028C12.454 17.8756 12.454 16.2319 12.6444 14.6048C12.7793 13.4516 13.7034 12.5539 14.8444 12.4264Z"
            fill="#241E40"
            fillOpacity="0.85"
          />
        </svg>
      ),
      path: "/dich-vu",
    },
    // {
    //   svg: (
    //     <svg
    //       width="18"
    //       height="22"
    //       viewBox="0 0 18 22"
    //       fill="none"
    //       xmlns="http://www.w3.org/2000/svg"
    //     >
    //       <path
    //         fill-rule="evenodd"
    //         clip-rule="evenodd"
    //         d="M3.84173 6.13018V5.99856C3.84173 3.61858 5.46292 1.54053 7.78207 0.947819C8.63928 0.728738 9.53833 0.728738 10.3955 0.947819C12.7147 1.54053 14.3359 3.61859 14.3359 5.99857V6.13018H15.9941C16.6252 6.13018 17.1607 6.59018 17.2522 7.21077L17.4938 8.84934C17.9694 12.0755 17.9694 15.3533 17.4938 18.5795C17.2641 20.1374 16.0001 21.3419 14.4242 21.5043L13.7296 21.5759C10.644 21.8939 7.53361 21.8939 4.44803 21.5759L3.75335 21.5043C2.17753 21.3419 0.913493 20.1374 0.683817 18.5795C0.208218 15.3533 0.208218 12.0755 0.683817 8.84934L0.925375 7.21077C1.01686 6.59018 1.55245 6.13018 2.18351 6.13018H3.84173ZM8.19472 2.54279C8.78124 2.39289 9.39637 2.39289 9.98289 2.54279C11.5697 2.94833 12.6789 4.37016 12.6789 5.99857V6.13018H5.4987V5.99856C5.4987 4.37016 6.60794 2.94833 8.19472 2.54279ZM3.84173 7.77704V10.2473C3.84173 10.7021 4.21265 11.0708 4.67021 11.0708C5.12777 11.0708 5.4987 10.7021 5.4987 10.2473V7.77704H12.6789V10.2473C12.6789 10.7021 13.0498 11.0708 13.5074 11.0708C13.965 11.0708 14.3359 10.7021 14.3359 10.2473V7.77704H15.661L15.8543 9.08809C16.3066 12.1559 16.3066 15.2729 15.8543 18.3407C15.7345 19.1533 15.0752 19.7815 14.2533 19.8662L13.5586 19.9378C10.5867 20.2442 7.59088 20.2442 4.61895 19.9378L3.92427 19.8662C3.10236 19.7815 2.44308 19.1533 2.32328 18.3407C1.87102 15.2729 1.87102 12.1559 2.32328 9.08809L2.51656 7.77704H3.84173Z"
    //         fill="#241E40"
    //         fill-opacity="0.85"
    //       />
    //     </svg>
    //   ),
    //   path: "/san-pham",
    // },
    {
      svg: (
        <svg
          width="19"
          height="22"
          viewBox="0 0 19 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.87278 6.04773C4.87278 3.14038 7.02396 0.783508 9.67758 0.783508C12.3312 0.783508 14.4824 3.14038 14.4824 6.04773C14.4824 8.95507 12.3312 11.3119 9.67758 11.3119C7.02396 11.3119 4.87278 8.95507 4.87278 6.04773ZM9.67758 2.64147C7.96053 2.64147 6.56859 4.1665 6.56859 6.04773C6.56859 7.92895 7.96053 9.45398 9.67758 9.45398C11.3946 9.45398 12.7866 7.92895 12.7866 6.04773C12.7866 4.1665 11.3946 2.64147 9.67758 2.64147Z"
            fill="#241E40"
            fillOpacity="0.85"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.15542 15.0279C3.75056 15.0279 2.6117 16.2756 2.6117 17.8148V19.2867C2.6117 19.3091 2.62653 19.3282 2.64672 19.3318C7.30313 20.1647 12.052 20.1647 16.7084 19.3318C16.7286 19.3282 16.7434 19.3091 16.7434 19.2867V17.8148C16.7434 16.2756 15.6046 15.0279 14.1997 15.0279H13.8144C13.7846 15.0279 13.755 15.033 13.7266 15.0432L12.7481 15.3932C10.7529 16.107 8.60222 16.107 6.60701 15.3932L5.62851 15.0432C5.60019 15.033 5.57058 15.0279 5.54078 15.0279H5.15542ZM0.915894 17.8148C0.915894 15.2495 2.81399 13.1699 5.15542 13.1699H5.54078C5.74936 13.1699 5.95662 13.206 6.1549 13.277L7.13339 13.627C8.78656 14.2185 10.5686 14.2185 12.2218 13.627L13.2003 13.277C13.3985 13.206 13.6058 13.1699 13.8144 13.1699H14.1997C16.5412 13.1699 18.4393 15.2495 18.4393 17.8148V19.2867C18.4393 20.2196 17.8221 21.0151 16.9817 21.1655C12.1443 22.0308 7.21085 22.0308 2.37347 21.1655C1.53304 21.0151 0.915894 20.2196 0.915894 19.2867V17.8148Z"
            fill="#241E40"
            fillOpacity="0.85"
          />
        </svg>
      ),
      path: "/lien-he",
    },
  ];
  return (
    <div className="nav-menu-mobile">
      <div className="nav-flex">
        {MENU_ITEMS.map((item, index) => {
          return (
            <div
              key={index}
              className={` ${
                pathname.startsWith(item.path) ? "mobile-nav" : ""
              }`}
            >
              <Link key={item.path} to={item.path}>
                {item.svg}
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default NavbarMobile;
